define('home/mixins/withCollapsing',[
    'underscore',
    'jquery',
], function (
    _,
    $
) {
    'use strict';

    var getCollapsible = function (options) {
        return options.collapsibleSelector ?
            this.$(options.collapsibleSelector) :
            this.$el;
    };

    var CollapsingMixin = {
        events: {
            'click [data-action=expand]': 'expand',
            'click [data-action=collapse]': 'forceCollapse',
        },

        collapse: function (options) {
            var $collapsible = getCollapsible.call(this, options);

            var imagePromises = $collapsible.find('img').map(function (__, el) {
                var deferred = $.Deferred();
                var $el = $(el);

                if ($el.complete)
                    deferred.resolve();
                else
                    $el.one('load', deferred.resolve);

                return deferred.promise();
            });

            // Wait until all images (if any) are loaded before deciding whether
            // or not to collapse this element. If no images, no need to wait, element
            // is already at its max height. (ex: long post with no images may still
            // exceed maxHeight)
            $.when(imagePromises).then(_.bind(this.forceCollapse, this, null, options));
        },

        expand: function (evt, options) {
            if (evt)
                evt.preventDefault();

            var $collapsible = getCollapsible.call(this, options);
            var $expand = $collapsible.find('[data-action=expand][data-target]');
            var $collapse = $collapsible.find('[data-action=collapse]');
            var selector = $expand.data('target');
            var $element = $collapsible.find(selector);
            var self = this;

            $expand.addClass('hidden');
            $element
                .addClass('expanded')
                .one('transitionend oTransitionEnd webkitTransitionEnd', function () {
                    self.trigger('expandedComplete');
                });

            $collapse.removeClass('hidden');
        },

        forceCollapse: function (evt, options) {
            if (evt)
                evt.preventDefault();

            var $collapsible = getCollapsible.call(this, options);

            var $expand = $collapsible.find('[data-action=expand]');
            var $collapse = $collapsible.find('[data-action=collapse]');

            var selector = evt ?
                $(evt.currentTarget).data('target') :
                '.expanded';
            var $element = $collapsible.find(selector);

            // Don't collapse something if there's no way to re-expand it
            if (!$expand.length)
                return;

            if ($element.height() > options.maxHeight) {
                $element.removeClass('expanded');
                $expand.removeClass('hidden');
            }

            $collapse.addClass('hidden');
        },
    };

    var withCollapsing = function (options) {
        var _initialize = this.initialize;

        this.initialize = function () {
            _initialize.apply(this, arguments);
            this.listenTo(this, 'show', this.collapse);
        };

        this.collapse = function () {
            CollapsingMixin.collapse.call(this, options);
        };

        this.expand = function (evt) {
            CollapsingMixin.expand.call(this, evt, options);
        };

        this.forceCollapse = function (evt) {
            CollapsingMixin.forceCollapse.call(this, evt, options);
        };

        this.events = _.defaults({}, this.events, CollapsingMixin.events);
    };

    return withCollapsing;
});

